import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastService } from 'src/app/services/toast.service';
import { TranslateService } from 'src/app/services/translate.service';

export interface IOutlierReasonData {
  outlierReason: string;
}

@Component({
  standalone: false,
  selector: 'app-outlier-reason-dialog',
  templateUrl: './outlier-reason-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./../../shared/form/form.component.scss']
})
export class OutlierReasonDialogComponent {
  constructor(private dialogRef: MatDialogRef<OutlierReasonDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IOutlierReasonData,
    private toastService: ToastService,
    private translateService: TranslateService) {
  }

  onSave(): void {
    const reason = this.data?.outlierReason?.trim();
    if (!reason) {
      const errorMessage = this.translateService.getDynamicTranslation('Outlier reason is required');
      this.toastService.displayErrorMessage(errorMessage, true);
      return;
    }
    this.dialogRef.close(reason);
  }
}
